import * as React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import c from 'classnames';

import { Clickable } from '../../types';
import { colors } from '../../styles';

import { ContentOptions } from './';

export interface Options {
  content?: ContentOptions;
  heading?: {};
}
export interface Props extends Options, Clickable {
  className?: string;
  open?: boolean;
}
interface State {
  open: boolean;
}
class Item extends React.Component<Props, State> {
  public static defaultProps: Props = {
    content: {},
    heading: {},
    open: false,
    onClick: () => null,
  };

  constructor(props: Props) {
    super(props);
    this.state = { open: props.open };
  }

  public componentWillReceiveProps(nextProps) {
    this.setState({ open: nextProps.open });
  }

  public render() {
    const {
      className,
      children,
      content: contentOptions,
      heading: headingOptions,
    } = this.props;
    const { open } = this.state;
    const [heading, content, ...rest] = React.Children.toArray(children) as [
      React.ReactElement<any>,
      React.ReactElement<any>
    ];

    return (
      <li className={c(className, { open })}>
        {heading &&
          React.cloneElement(heading, {
            ...headingOptions,
            className: c(heading.props.className, 'heading'),
            onClick: this.handleToggleClick,
            open,
          })}
        {content &&
          React.cloneElement(content, {
            ...contentOptions,
            className: c(content.props.className, 'content'),
            open,
          })}
        {rest}
      </li>
    );
  }

  private handleToggleClick = e => {
    this.setState((prevState, props) => ({ open: !prevState.open }));
    this.props.onClick(e);
  };
}

export default styled(Item)`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  list-style-type: none;
  position: relative;
  z-index: 0;

  .content {
    z-index: 2;
  }

  .heading {
    z-index: 1;
  }
`;
